// HTTP error types — mirror avatar-customer-portal's shape so handler code
// reads identically across our frontends.

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

export class UnauthorizedError extends Error {
  status = 401
  constructor() {
    super('Unauthorized')
    this.name = 'UnauthorizedError'
  }
}
